import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { Subject } from 'rxjs';
import {
  ITrackingAction,
  ITrackingObject,
  TrackingDialogNamesEnum,
  TrackingScreenNamesEnum,
  ITrackingProperties,
} from '../../../tracking/tracking.data';
import { DialogActionsEnum, IDialogTrigger } from '../../dialog.data';
import { DialogService } from '../../dialog.service';
import { IConfirmDialogResult } from './confirm-dialog.interface';
import { filter, takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-confirm-dialog',
  templateUrl: 'confirm-dialog.component.html',
  styleUrls: ['confirm-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConfirmDialogComponent implements OnInit, OnDestroy {
  @Input() dialogId: string;
  @Input() removeIdPrefix: boolean;
  @Input() confirmTitle: string;
  @Input() confirmPrompt: string;
  @Input() yesText: string;
  @Input() cancelText: string;
  @Input() isDeleteAction: boolean;
  @Input() trackingObject: ITrackingObject;
  @Input() trackingScreenName: TrackingScreenNamesEnum;
  @Input() trackingDialogName: TrackingDialogNamesEnum;
  @Input() primaryActionTapped: ITrackingAction;
  @Input() primaryActionTrackingAdditionalProperties: ITrackingProperties;
  @Input() secondaryActionTapped: ITrackingAction;
  @Input() secondaryActionTrackingAdditionalProperties: ITrackingProperties;
  @Input() dismissActionTapped: ITrackingAction;
  @Input() trackingAdditionalProperties: ITrackingProperties;

  @Output()
  onClose: EventEmitter<IConfirmDialogResult> = new EventEmitter<IConfirmDialogResult>();

  private _dialogData: any;
  private _destroyed: Subject<boolean> = new Subject<boolean>();

  dialogType: string;

  constructor(private _dialogService: DialogService) {}

  ngOnInit() {
    this.dialogType = this.removeIdPrefix
      ? this.dialogId
      : `confirm-${this.dialogId}`;

    this._dialogService.dialogTriggers$
      .pipe(
        filter(
          ({ type, action }: IDialogTrigger) =>
            type === this.dialogType && action === DialogActionsEnum.open
        ),
        takeUntil(this._destroyed)
      )
      .subscribe(({ data }: IDialogTrigger) => (this._dialogData = data));
  }

  onSecondaryAction() {
    this.onClose.emit({ result: false, data: this._dialogData });
  }

  onPrimaryAction() {
    this.onClose.emit({ result: true, data: this._dialogData });
  }

  onCancelAction() {
    this.onClose.emit({ result: null, data: this._dialogData });
  }

  ngOnDestroy() {
    this._destroyed.next(true);
    this._destroyed.unsubscribe();
  }
}
